import { GetClientAppSettingsResponse, SentrySettings } from "./api/Neon.Dtos";

export interface ISentrySettings {
    dsn?: string;
    customer: string;
    environment: string;
    sendDefaultPii: boolean;
    enableMetrics: boolean;
    attachStacktrace: boolean;
    debug: boolean;
    application: string;
    release?: string;
    replaysSessionSampleRate: number;
    replaysOnErrorSampleRate: number;
    enableLogs: boolean;
    tracesSampleRate: number;
    enableReportABug: boolean;
}

export interface IAppSettings {
    trialPortalUrl: string;
    redactUrl: string;
    ecrfUrl: string;
    sentry: ISentrySettings;
};

const ClientAppSettingsResponse: GetClientAppSettingsResponse | undefined = (window as any).APP_SETTINGS;

const getSentryAppSettingValue = <TData>(
    appSettingProperty: keyof SentrySettings | undefined
): TData | undefined => {
    if (!appSettingProperty) {
        return undefined;
    }
    const value: TData | undefined = ClientAppSettingsResponse?.settings?.sentry?.[appSettingProperty] as TData;
    if (value === undefined || value === null) {
        return undefined;
    }
    return value;
};
const getSentryString = (
    appSettingProperty: keyof SentrySettings | undefined
) => {
    const appSettingValue = getSentryAppSettingValue<string>(appSettingProperty);
    if (appSettingValue) {
        return appSettingValue;
    }
    return undefined;
};

const getSentryNumber = (
    appSettingProperty: keyof SentrySettings | undefined
) => {
    const appSettingValue = getSentryAppSettingValue<number>(appSettingProperty);
    if (appSettingValue !== null && appSettingValue !== undefined) {
        return appSettingValue;
    }
    return undefined;
};

const getSentryBoolean = (
    appSettingProperty: keyof SentrySettings | undefined
) => {
    const appSettingValue = getSentryAppSettingValue<boolean>(appSettingProperty);
    if (appSettingValue !== null && appSettingValue !== undefined) {
        return appSettingValue;
    }
    return undefined;
};

export const AppSettings: IAppSettings = {
    trialPortalUrl: (window as any).TRIAL_PORTAL_URL ?? "https://redact.breastcancertrials.org.au",
    redactUrl: (window as any).REDACT_URL_NO_SLASH ?? "https://redact.breastcancertrials.org.au",
    ecrfUrl: (window as any).ECRF_URL ?? "https://ecrf.breastcancertrials.org.au/",
    sentry: {
        dsn: getSentryString('dsn'),
        debug: getSentryBoolean('debug') ?? false,
        enableMetrics: getSentryBoolean('enableMetrics') ?? false,
        sendDefaultPii: getSentryBoolean('sendDefaultPii') ?? false,
        attachStacktrace: getSentryBoolean('attachStacktrace') ?? false,
        customer: getSentryString('customer') ?? 'BCT',
        environment:  getSentryString('environment') ?? 'Development',
        application: getSentryString('application') ?? 'NeonOpms',
        release: process.env.REACT_APP_SENTRY_RELEASE,
        enableLogs: getSentryBoolean('enableLogs') ?? false,
        replaysOnErrorSampleRate: getSentryNumber('replaysOnErrorSampleRate') ?? 1.0,
        replaysSessionSampleRate: getSentryNumber('replaysSessionSampleRate') ?? 0.1,
        tracesSampleRate: getSentryNumber('tracesSampleRate') ?? 0.2,
        enableReportABug: getSentryBoolean('enableReportABug') ?? false
    }
};
